import React from "react";

function ActionRSECard({ name, description, reward, picture, language = "fr" }) {
  let parsedName = name;
  let parsedDescription = description;

  try {
    parsedName = typeof name === "string" ? JSON.parse(name) : name;
  } catch (e) {
    console.warn("Erreur parsing name:", name);
  }

  try {
    parsedDescription = typeof description === "string" ? JSON.parse(description) : description;
  } catch (e) {
    console.warn("Erreur parsing description:", description);
  }

  return (
    <div className="action-card">
      <div className="overlay-title">
        <h3>{parsedName?.[language] || parsedName?.fr}</h3>
      </div>
      <div className="image-container">
        <img src={picture} alt={parsedName?.[language]} className="action-image" />
        <div className="reward-badge">+ {reward}</div>
      </div>
      <div className="action-description">
        <p>{parsedDescription?.[language] || parsedDescription?.fr}</p>
      </div>
    </div>
  );
}

export default ActionRSECard;
